import React from 'react'
import { withRouter } from 'react-router'
import { Redirect, Route, Switch } from 'react-router-dom'
import PropTypes from 'prop-types'

import { ConnectedToastsContainer } from '../../@paco/connectors'
import {
    AbsenceDetailPage,
    AbsenceEditPage,
    AbsencesPage,
    LanguagePage,
    LeaveOfAbsencesPage,
    LeaveRequestPage,
    SchedulePage,
} from '../../@paco/pages'

import {
    MY_EXCHANGES,     MY_SHIFTS, OFFERED_EXCHANGES,
    OPEN_SHIFTS } from '../../constants'
import { translate } from '../../helpers/translations/translator'
import LoketHoursPerPeriod from '../../pages/Absences/LoketHoursPerPeriod'
import LoketLeaveBalances from '../../pages/Absences/LoketLeaveBalances'
import ChangePasswordPincode from '../../pages/ChangePasswordPincode/ChangePasswordPincode'
import Documents from '../../pages/Documents/Documents'
import ErrorPage from '../../pages/ErrorPage'
import ExchangeDetail from '../../pages/Exchanges/ExchangeDetail'
import Exchanges from '../../pages/Exchanges/Exchanges'
import ShiftExchangeDetail from '../../pages/Exchanges/ShiftExchangeDetail'
import CreatePlanningPreference from '../../pages/PlanningPreferences/CreatePlanningPreference'
import PlanningPreferenceDetail from '../../pages/PlanningPreferences/PlanningPreferenceDetail'
import PlanningPreferences from '../../pages/PlanningPreferences/PlanningPreferences'
import Profile from '../../pages/Profile/Profile'
import ProfileDetail from '../../pages/Profile/ProfileDetail'
import ExchangeShift from '../../pages/Shifts/ExchangeShift/ExchangeShift'
import ShiftRegister from '../../pages/Shifts/Register/ShiftRegister'
import Shifts from '../../pages/Shifts/Shifts'
import ShiftsDetail from '../../pages/Shifts/ShiftsDetail'
import Tracks from '../../pages/Tracks/Tracks'
import TracksDetail from '../../pages/Tracks/TracksDetail'
import Layout from '../Layout/Layout'

const PrivateRouteGroup = ({ isAuthenticated, ...rest }) => {
    const shiftsPath = `/${translate('nav.shifts.link')}`
    const exchangeShiftPath = `/${translate('nav.shifts.exchange.link')}`
    const myShiftsPath = `/${translate('nav.shifts.link')}/${translate('nav.shifts.myShifts.link')}`
    const openShiftsPath = `/${translate('nav.shifts.link')}/${translate('nav.shifts.openShifts.link')}`
    const schedulePath = `/${translate('nav.shifts.link')}/${translate('nav.shifts.schedule.link')}`
    const myExchangesPath = `/${translate('nav.exchanges.link')}/${translate('nav.exchanges.myExchanges.link')}`
    const offeredExchangesPath = `/${translate('nav.exchanges.link')}/${translate('nav.exchanges.offeredExchanges.link')}`
    const absencesPath = `/${translate('nav.absences.link')}/${translate('nav.absences.absences.link')}`
    const leaveOfAbsenceOverviewPath = `/${translate('nav.absences.link')}/${translate('nav.absences.leaveOfAbsenceOverview.link')}`
    const loketHoursPerPeriodPath = `/${translate('nav.absences.link')}/${translate('nav.absences.loketHoursPerPeriod.link')}`
    const leaveOfAbsenceRequestsPath = `/${translate('nav.absences.link')}/${translate('nav.absences.leaveOfAbsenceRequests.link')}`
    const createAbsencesPath = `/${translate('nav.absences.link')}/${translate('nav.absences.createAbsences.link')}`
    const planningPrefPath = `/${translate('nav.planningPreferences.link')}`
    const planningPrefDetailPath = `${planningPrefPath}/:planningPreferenceId`
    const createPlanningPrefPath = `${planningPrefPath}/${translate('nav.planningPreferences.createPlanningPreference.link')}`
    const tracksPath = `/${translate('nav.tracks.link')}`
    const profilePath = `/${translate('nav.profile.link')}`
    const changePassPath = `${profilePath}/${translate('nav.changePasswordPincode.link')}`
    const profileDetailPath = `${profilePath}/:detailId`
    const languagePath = `/${translate('nav.language.link')}`

    return (
        <>
            <Layout>
                <Route
                    {...rest}
                    render={() => (isAuthenticated === true ? (
                        <Switch>

                            { /* Tracks */ }
                            <Route exact path={tracksPath} component={Tracks} />
                            <Route
                                exact
                                path="/"
                                render={() => (
                                    <Redirect
                                        to={tracksPath}
                                    />
                                )}
                            />
                            <Route exact path={`/${translate('nav.tracks.link')}/:trackUuid`} component={TracksDetail} />

                            { /* Shifts */ }
                            <Route
                                exact
                                path={myShiftsPath}
                                render={props => <Shifts {...props} tab={MY_SHIFTS} />}
                            />
                            <Route
                                exact
                                path={openShiftsPath}
                                render={props => <Shifts {...props} tab={OPEN_SHIFTS} />}
                            />
                            <Route
                                exact
                                path={shiftsPath}
                                render={() => (
                                    <Redirect
                                        to={myShiftsPath}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path={schedulePath}
                                render={props => <SchedulePage {...props} />}
                            />
                            <Route exact path={`${shiftsPath}/:shiftUuid`} component={ShiftsDetail} />
                            <Route exact path={`${shiftsPath}/:shiftUuid${exchangeShiftPath}`} component={ExchangeShift} />

                            <Route
                                exact
                                path={`${shiftsPath}/:shiftUuid/${translate('nav.shifts.register.link')}`}
                                component={ShiftRegister}
                            />

                            { /* Exchanges */ }
                            <Route
                                exact
                                path={myExchangesPath}
                                render={props => <Exchanges {...props} tab={MY_EXCHANGES} />}
                            />
                            <Route
                                exact
                                path={offeredExchangesPath}
                                render={props => <Exchanges {...props} tab={OFFERED_EXCHANGES} />}
                            />
                            <Route
                                exact
                                path={`/${translate('nav.exchanges.link')}`}
                                render={() => (
                                    <Redirect
                                        to={myExchangesPath}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path={`/${translate('nav.exchanges.link')}/:exchangeUuid`}
                                component={ExchangeDetail}
                            />
                            <Route
                                exact
                                path={`/${translate('nav.exchanges.shiftExchange.link')}/:exchangeUuid`}
                                component={ShiftExchangeDetail}
                            />

                            { /* Absences */ }
                            <Route
                                exact
                                path={leaveOfAbsenceOverviewPath}
                                render={props => (
                                    <LoketLeaveBalances {...props} />
                                )}
                            />
                            <Route
                                exact
                                path={loketHoursPerPeriodPath}
                                render={props => (
                                    <LoketHoursPerPeriod {...props} />
                                )}
                            />
                            <Route
                                exact
                                path={leaveOfAbsenceRequestsPath}
                                render={props => <LeaveOfAbsencesPage {...props} />}
                            />
                            <Route
                                exact
                                path={absencesPath}
                                render={props => <AbsencesPage {...props} />}
                            />
                            <Route
                                exact
                                path={`/${translate('nav.absences.link')}`}
                                render={() => (
                                    <Redirect
                                        to={leaveOfAbsenceRequestsPath}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path={createAbsencesPath}
                                component={LeaveRequestPage}
                            />

                            <Route
                                exact
                                path={`/${translate('nav.absences.link')}/:id`}
                                component={AbsenceDetailPage}
                            />

                            <Route
                                exact
                                path={`/${translate('nav.absences.link')}/:id/${translate('common.edit')}`}
                                component={AbsenceEditPage}
                            />

                            { /* Documents */ }
                            <Route exact path={`/${translate('nav.documents.link')}`} component={Documents} />

                            { /* Password & Pincode */ }
                            <Route
                                exact
                                path={changePassPath}
                                component={ChangePasswordPincode}
                            />

                            { /* Planning preference create */ }
                            <Route
                                exact
                                path={createPlanningPrefPath}
                                component={CreatePlanningPreference}
                            />

                            { /* Planning preference */ }
                            <Route
                                exact
                                path={planningPrefDetailPath}
                                component={PlanningPreferenceDetail}
                            />

                            <Route
                                exact
                                path={planningPrefPath}
                                component={PlanningPreferences}
                            />

                            { /* Profile */ }
                            <Route
                                path={profileDetailPath}
                                component={ProfileDetail}
                            />

                            <Route
                                exact
                                path={profilePath}
                                component={Profile}
                            />

                            { /* Language */ }
                            <Route
                                path={languagePath}
                                component={LanguagePage}
                            />

                            { /* Error */ }
                            <Route render={props => <ErrorPage {...props} errorCode={404} />} />
                        </Switch>
                    ) : (
                        <Redirect to={`/${translate('nav.login.link')}`} />
                    ))
                    }
                />
            </Layout>
            <ConnectedToastsContainer />
        </>
    )
}

PrivateRouteGroup.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
}

export default withRouter(PrivateRouteGroup)
